module.exports = __webpack_public_path__ + "img/new-status.e771a83b.svg";